require('goodshare.js');